import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Input } from 'antd';
import { AuthContext } from '../../components/Context';
import logo from '../../components/images/ttel.png';
import { useGetEventsById, useGetParticipantByPhone } from "../../components/services/operation.service";
import { useLocation } from "react-router-dom";
import GeoAddress from "../../components/GeoAddress";

function LoginForm() {

    const { login, setEvent, event } = useContext(AuthContext);

    // const location = useLocation();
    const pathname = window.location.pathname.split('/');

    const [mobilePhone, setMobilePhone] = useState('');
    const [phoneNumber, setPhoneNumber] = useState(null);

    const { data: userData, isFetched: isUserFetched } = useGetParticipantByPhone(phoneNumber);
    const { data: eventData, isFetched: isEventFetched } = useGetEventsById(pathname?.[2] || null);

    useEffect(() => {

        if (isUserFetched && userData?.data) {
            login(mobilePhone, userData.data);
        }

    }, [isUserFetched, userData?.data]);

    useEffect(() => {

        if (isEventFetched && eventData?.data) {
            setEvent(eventData.data);
            localStorage.removeItem('participant_event');
            localStorage.setItem('participant_event', JSON.stringify(eventData.data));
        }

    }, [isEventFetched, eventData?.data]);

    const handleSubmit = (e) => {
        if (mobilePhone !== '') {
            setPhoneNumber(mobilePhone);
        }
    };

    return (
        <div style={{ textAlign: 'center' }}>
            {/* <img src={logo} alt="T-tel Logo"  style={{maxWidth:'120px'}} /> */}
            <h2>Participant Login</h2>
            <hr />
            <div style={{ padding: '20px', margin: '0 auto', maxWidth: '300px', minHeight: '250px' }}>

                <Form name="login" onFinish={handleSubmit} layout="vertical" >
                    <Form.Item
                        label="Enter Phone Number"
                        name="mobileNumber"
                        rules={[{ required: true, message: 'Please input your phone number!' }]}>
                        <Input
                            type="text"
                            value={mobilePhone}
                            onChange={(e) => setMobilePhone(e.target.value)}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            </div>
            <hr />
            <div style={{ marginBottom: '20px' }}><small>Powered by <a href="#">AO Holdings</a></small></div>
        </div>
    );
}

export default LoginForm;
